module.exports = __webpack_public_path__ + "img/snow.a83f2e91.svg";